import * as React from 'react';
import { cn } from '@/lib/utils';
import propsTypes from 'prop-types';
const Input = React.forwardRef(
  ({ className, type = 'text', icon, iconPosition = '', ...props }, ref) => {
    return (
      <div className="relative flex items-center">
        <input
          type={type}
          className={cn(
            `flex h-11 w-full rounded-sm border border-input text-foreground bg-background ${iconPosition ? (iconPosition === 'left' ? 'pl-9' : 'pl-3') : 'px-3'} py-2 pr-10 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:text-foreground file:font-medium placeholder:text-placeholder focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50`,
            className,
          )}
          ref={ref}
          {...props}
        />
        {icon && (
          <div
            className={`absolute ${iconPosition === 'left' ? 'left-3' : 'right-3'} flex items-center`}
          >
            {icon}
          </div>
        )}
      </div>
    );
  },
);
Input.displayName = 'Input';

export { Input };

Input.propTypes = {
  className: propsTypes.string,
  type: propsTypes.string,
  icon: propsTypes.node,
};
